// pet values
export const CatMaxWeightInKg = 20 as const;
export const DogMaxWeightInKg = 120 as const;
export const PetMaxAgeInYears = 24 as const;

// box values
export const DogTubWeightInGrams = 500 as const;
export const CatTubWeightInGrams = 250 as const;

// subscription values
export const MaxDeliveryIntervalInDays = 80 as const;
export const MinDeliveryIntervalInDays = 7 as const;
export const MinBoxSizeInGrams = 4000 as const;
export const MinPortionIncrementInGrams = 25 as const;

// units values
export const KgToLbsRatio = 2.20462 as const;
export const HOUR_IN_SECONDS = 3600;
